// Messages for operator/Shipments (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.shipments.head': 'Shipments — Operator',
  'operator.shipments.title': 'Shipments',
  'operator.shipments.subtitle': '{count} shown · all customers · live tracking',
  'operator.shipments.create': 'Create shipment',
  'operator.shipments.search.aria': 'Search shipments',
  'operator.shipments.search.placeholder': 'Search HBL, ref, PO, container, customer…',
  'operator.shipments.status.active': 'Active',
  'operator.shipments.status.all': 'All',
  'operator.shipments.filter.customer.aria': 'Filter by customer',
  'operator.shipments.filter.customer.all': 'All customers',
  'operator.shipments.filter.carrier.aria': 'Filter by carrier',
  'operator.shipments.filter.carrier.all': 'All carriers',
  'operator.shipments.filter.destination.aria': 'Filter by destination',
  'operator.shipments.filter.destination.all': 'All destinations',
  'operator.shipments.mode.all': 'All',
  'operator.shipments.mode.ship': 'Ocean',
  'operator.shipments.mode.air': 'Air',
  'operator.shipments.mode.truck': 'Truck',
  'operator.shipments.mode.train': 'Rail',
  'operator.shipments.clear': 'Clear',
  'operator.shipments.col.hbl_customer': 'HBL / Customer',
  'operator.shipments.col.shipment_pos': 'Shipment & POs',
  'operator.shipments.more_pos': '{count} more POs',
  'operator.shipments.col.route_status': 'Route & Status',
  'operator.shipments.col.eta': 'ETA',
  'operator.shipments.empty': 'No shipments match these filters.',
  'operator.shipments.percent_complete': '{percent}% complete',
  'operator.shipments.load_more': 'Load more',
  'operator.shipments.loading': 'Loading…',
}

export const zhTW = {
  'operator.shipments.head': '貨件 — 操作端',
  'operator.shipments.title': '貨件',
  'operator.shipments.subtitle': '顯示 {count} 件 · 所有客戶 · 即時追蹤',
  'operator.shipments.create': '建立貨件',
  'operator.shipments.search.aria': '搜尋貨件',
  'operator.shipments.search.placeholder': '搜尋 HBL、參考號、PO、貨櫃、客戶…',
  'operator.shipments.status.active': '進行中',
  'operator.shipments.status.all': '全部',
  'operator.shipments.filter.customer.aria': '依客戶篩選',
  'operator.shipments.filter.customer.all': '所有客戶',
  'operator.shipments.filter.carrier.aria': '依承運商篩選',
  'operator.shipments.filter.carrier.all': '所有承運商',
  'operator.shipments.filter.destination.aria': '依目的地篩選',
  'operator.shipments.filter.destination.all': '所有目的地',
  'operator.shipments.mode.all': '全部',
  'operator.shipments.mode.ship': '海運',
  'operator.shipments.mode.air': '空運',
  'operator.shipments.mode.truck': '卡車',
  'operator.shipments.mode.train': '鐵路',
  'operator.shipments.clear': '清除',
  'operator.shipments.col.hbl_customer': 'HBL / 客戶',
  'operator.shipments.col.shipment_pos': '貨件與 PO',
  'operator.shipments.more_pos': '另有 {count} 筆 PO',
  'operator.shipments.col.route_status': '路線與狀態',
  'operator.shipments.col.eta': '預計到達',
  'operator.shipments.empty': '沒有符合這些篩選條件的貨件。',
  'operator.shipments.percent_complete': '完成 {percent}%',
  'operator.shipments.load_more': '載入更多',
  'operator.shipments.loading': '載入中…',
}
